import React from 'react'
import Header from './components/Header'
import Home from './components/Home'
import About from './components/About'
import Contact from './components/Contact'
import { Routes, Route } from "react-router-dom";
// import Slider from './components/Slider'
import './App.css';
import Register from './components/auth/Register';
import Login from './components/auth/Login';

export default function App() {
  return (  
    <div>
        <Header />
        <div className='container-fluid'>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/register" element={<Register />} />
                <Route path="/login" element={<Login />} />
            </Routes>
        </div>
    </div>
  )
}
